import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux'; 


const MediBusinessProfileForm = () => {
  const authState = useSelector(state => state.authReducer);
  const [submitstatus, setSubmitstatus] = useState('');
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [dealCode, setDealCode] = useState('1234567890');
  const [formData, setFormData] = useState({
    businessName: '',
    businessCode: '',
    contactEmail: '',
    phone: '',
    website: '',
    businessType: '',
    location: '',
    isApproved: false,
    isActive: false,
    tags: '',
    businessInfo: '',
  });

  const [submitStatus, setSubmitStatus] = useState('');
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const config = {
      url: '/businessprofile',
      method: 'post',
      data: formData,
      headers: { Authorization: authState.token }
    };
// console.log("confog: ",config);
    try {
      const response = await fetchData(config);

      if (response && response.status) {
        setSubmitStatus('Thank you! Your request has been submitted and is under verification process.');
        setIsError(false);
        setFormData({
          businessName: '',
          businessCode: '',
          contactEmail: '',
          phone: '',
          website: '',
          businessType: '',
          location: '',
          isApproved: false,
          isActive: false,
          tags: '',
          businessInfo: '',
        });
      } else {
        setSubmitStatus('Sorry, we encountered an issue while submitting your deal.');
        setIsError(true);
      }
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitStatus('Something went wrong. Please try again later.');
      setIsError(true);
    }
  };

  return (
    <section id="business" className="py-4 px-4 bg-black text-white text-center border border-blue-400">
      <h2 className="text-md lg:text-xl font-bold mb-6 text-yellow-200">Are You a Business (Pharma Company, Importer, Distributors?</h2>
      <p className="text-sm lg:text-m mb-2 mx-auto text-gray-200">
        Join MediFinder to showcase your medicine. Get started with your business profile today.
      </p>
      <form
          onSubmit={handleSubmit}
          className="mx-auto bg-black text-white p-6 rounded-lg shadow-md text-left
                    [&_input]:text-black [&_textarea]:text-white [&_select]:text-black"
        >
        <select name="businessType" value={formData.businessType} onChange={handleChange} className="h-10 mb-4 w-full p-2 text-black border rounded" required>
          <option value="">Select Type</option>
          <option value="Pharma Company">Pharma Company</option>
          <option value="Importer">Importer</option>
          <option value="Distributor">Distributor</option>
          <option value="Others">Others</option>
        </select>
        <input name="businessName" value={formData.businessName} onChange={handleChange} placeholder="Business Name" className="mb-4 w-full p-2 border rounded" required />
        <input name="contactEmail" value={formData.contactEmail} onChange={handleChange} placeholder="Contact Email" type="email" className="mb-4 w-full p-2 border rounded" required />
        <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" className="mb-4 w-full p-2 border rounded" />
        <input name="website" value={formData.website} onChange={handleChange} placeholder="Website" className="mb-4 w-full p-2 border rounded" />
        <input name="location" value={formData.location} onChange={handleChange} placeholder="Location" className="mb-4 w-full p-2 border rounded" />
        <textarea name="businessInfo" value={formData.businessInfo} onChange={handleChange} style={{height: "250px"}} placeholder="Business Info" className="mb-4 w-full p-2 border rounded" required />
        <input name="businessCode" value={formData.businessCode} onChange={handleChange} placeholder="Business Code" className="mb-4 w-full p-2 border rounded" required />
        <input name="tags" value={formData.tags} onChange={handleChange} placeholder="Keywords" className="mb-4 w-full p-2 border rounded" />
        <button type="submit" className="w-full bg-pink-600 text-white p-2 rounded hover:bg-pink-700 transition">
          Register Your Business
        </button>
        {submitStatus && <p className={`mt-4 ${isError ? 'text-red-600' : 'text-green-600'}`}>{submitStatus}</p>}
      </form>
    </section>
  );
};

export default MediBusinessProfileForm;
